import React from "react";
import { MarkdownContent, Loading } from "@/shared/ui";
import { useTranslation } from "react-i18next";
import PolicyPageLayout from "../service-terms/PolicyPageLayout";
import { useDocumentContent } from "../shared/hooks/useDocumentContent";
import { PageSEO, HreflangTags, BreadcrumbSchema } from "@/shared/seo";

/**
 * Privacy Policy document version 2 (April 2026 Google User Data §5.7).
 */
const PrivacyPolicyVersion2: React.FC = () => {
  const { t } = useTranslation("@pages/policy");
  const { content, isLoading } = useDocumentContent(
    "privacy-policy",
    `# ${t("privacyPolicy.title")}\n\nContent coming soon.`,
    2
  );

  if (isLoading) return <Loading mode="section" size="lg" />;

  return (
    <>
      <PageSEO
        title={t("privacyPolicy.title")}
        description={t(
          "privacyPolicy.description",
          "Privacy Policy for Housien - Learn how we collect, use, and protect your personal data."
        )}
        noIndex={false}
      />
      <HreflangTags />
      <BreadcrumbSchema
        items={[
          { name: t("breadcrumb.home"), url: "/" },
          { name: t("privacyPolicy.title"), url: "/privacy/v2" },
        ]}
      />

      <PolicyPageLayout
        title={t("privacyPolicy.title")}
        lastUpdated="April 2026"
        version="2"
        lastUpdatedLabel={t("privacyPolicy.lastUpdated")}
        versionLabel={t("privacyPolicy.version")}
      >
        <MarkdownContent content={content} headingOffset={1} />
      </PolicyPageLayout>
    </>
  );
};

export default PrivacyPolicyVersion2;
